import { BufferGeometry } from '@seddi/three';
import { computeVertexNormalsF32, updateVertexAttributeF32 } from '../core/bufferGeometry';

/**
 * Update mesh positions.
 * @param geometry - Geometry.
 * @param data - Positions.
 */
export const updatePositions = (geometry: BufferGeometry, data: Float32Array) => {
  updateVertexAttributeF32(geometry, 'position', data, 3);
  computeVertexNormalsF32(geometry);
  geometry.computeBoundingSphere();
};
